export const SECTION_TITLE_CLASS = "tw:text-sm tw:font-medium tw:leading-none";
export const READ_ONLY_BOX_CLASS =
  "tw:flex tw:min-h-9 tw:w-full tw:items-center tw:rounded-md tw:border tw:border-neutral-200 tw:px-3 tw:py-2 tw:text-sm tw:shadow-xs";
